'use strict';

var RomSummaryTopOppDirective = function RomSummaryTopOppDirective() {
  return {
    restrict: 'E',
    template: require('../templates/rom-summary-top-opp.html'),
    controller: 'RomSummaryTopOppController',
    scope: {
      topOppMode: '=',
      resetChartHandler: '=',
      optWeek: '=',
      columnNote: '='
    },
    link: function link($scope) {
      $scope.$on('search-criteria:searchChangeEvent', $scope.setDefaultState);
    }
  };
};
RomSummaryTopOppDirective.$inject = [];
module.exports = RomSummaryTopOppDirective;